// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__msL8G","productName":"Table_productName__3YhVj"};